import type React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import { getAuthLandingPath } from '../../utils/authLanding'

const PublicRoute = (): React.JSX.Element => {
  const { isAuthenticated, isLoading, user } = useAuth()

  if (isLoading) return <></>

  return isAuthenticated ? <Navigate to={getAuthLandingPath(user)} replace /> : <Outlet />
}

export default PublicRoute
